import OverviewFilter from "../../components/Fleet/OverviewFilter";
import OverviewScores from "../../components/Fleet/OverviewScores";
import OverviewTable from "../../components/Fleet/OverviewTable";
import FleetMap from "../../components/Fleet/FleetMap";
import { getAllFleets } from "../../services/fleetService";
import { useEffect, useRef, useState } from "react";

const FleetOverview = () => {
  const [allFleets, setAllFleets] = useState([]);
  const [fleetData, setFleetData] = useState([]);
  const [vesselData, setVesselData] = useState([]);
  const [totalVesselCount, setTotalVesselCount] = useState(0);

  const [filters, setFilters] = useState({
    fleetId: null,
    status: [],
    loadCondition: [],
    weather: [],
    zone: [],
  });

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const response = await getAllFleets({});

        if (response.data) {
          setAllFleets(response.data);
          setFleetData(response.data);

          const totalCount = response.data.reduce(
            (sum, fleet) => sum + (fleet.count || 0),
            0
          );
          setTotalVesselCount(totalCount);

          const allVessels = response.data.flatMap(
            (fleet) =>
              fleet.vessels?.map((vessel) => ({
                ...vessel,
                fleetName: fleet.fleetName,
                fleetId: fleet.fleetId,
              })) || []
          );
          setVesselData(allVessels);

          const ballastCount = allVessels.filter(
            vessel => vessel.status?.loadCondition?.toLowerCase() === 'ballast'
          ).length;

          const ladenCount = allVessels.filter(
            vessel => vessel.status?.loadCondition?.toLowerCase() === 'laden'
          ).length;

          const vesselsWithLoadCondition = allVessels.filter(
            vessel => vessel.status?.loadCondition
          ).length;

          console.log(' VESSEL LOAD CONDITION ANALYSIS:');
          console.log(' Total vessels:', allVessels.length);
          console.log(' Vessels with load condition data:', vesselsWithLoadCondition);
          console.log(' Ballast vessels:', ballastCount);
          console.log(' Laden vessels:', ladenCount);
          console.log(' Unknown load condition:', allVessels.length - vesselsWithLoadCondition);
          
          console.log(' INDIVIDUAL VESSEL LOAD CONDITIONS:');
          allVessels.forEach((vessel, index) => {
            console.log(`   ${index + 1}. ${vessel.vesselName}:`, {
              loadCondition: vessel.status?.loadCondition,
              hasStatus: !!vessel.status,
              hasLoadCondition: !!vessel.status?.loadCondition
            });
          });

          console.log(' SUMMARY:');
          console.log(`   Ballast count from vessel array: ${ballastCount}`);
          
          const totalBallastFromFleets = response.data.reduce(
            (sum, fleet) => sum + (fleet.loadCounts?.ballast || 0), 
            0
          );
          console.log(`   Ballast count from fleet summaries: ${totalBallastFromFleets}`);
          console.log(`   Match: ${ballastCount === totalBallastFromFleets ? 'Yes' : 'No'}`);
        }
      } catch (error) {
        console.error("Failed to fetch initial fleets:", error);
      }
    };

    fetchInitialData();
  }, []); // Empty dependency - runs only once on mount

  // useEffect(() => {
  //   const fetchInitialData = async () => {
  //     try {
  //       const response = await getAllFleets({}); // Empty filters = get all

  //       if (response.data) {
  //         // SET allFleets
  //         setAllFleets(response.data);
  //         setFleetData(response.data);

  //         // Calculate total vessels across all fleets
  //         const totalCount = response.data.reduce(
  //           (sum, fleet) => sum + (fleet.count || 0),
  //           0
  //         );
  //         setTotalVesselCount(totalCount);

  //         // Get all vessels (including those without position data)
  //         const allVessels = response.data.flatMap(
  //           (fleet) =>
  //             fleet.vessels?.map((vessel) => ({
  //               ...vessel,
  //               fleetName: fleet.fleetName,
  //               fleetId: fleet.fleetId,
  //             })) || []
  //         );
  //         setVesselData(allVessels);
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch initial fleets:", error);
  //     }
  //   };

  //   fetchInitialData();
  // }, []); // Empty dependency - runs only once on mount

  // When filters change, fetch filtered data
  
  useEffect(() => {
    const fetchFilteredData = async () => {
      try {
        const response = await getAllFleets(filters);

        console.log("Filtered ResponseData:", response.data);

        if (response.data) {
          setFleetData(response.data);

          const filteredVessels = response.data.flatMap(
            (fleet) =>
              fleet.vessels?.map((vessel) => ({
                ...vessel,
                fleetName: fleet.fleetName,
                fleetId: fleet.fleetId,
              })) || []
          );

          setVesselData(filteredVessels);
        }
      } catch (error) {
        console.error("Failed to fetch filtered fleets:", error);
      }
    };
    
    // Only fetch filtered data if there are active filters
    const hasActiveFilters = Object.values(filters).some((filter) =>
      Array.isArray(filter) ? filter.length > 0 : filter !== null
    );

    if (hasActiveFilters) {
      fetchFilteredData();
    } else {
      // If no filters, reset to show all data
      const fetchAllData = async () => {
        try {
          const response = await getAllFleets({});
          if (response.data) {
            setFleetData(response.data);
            const allVessels = response.data.flatMap(
              (fleet) =>
                fleet.vessels?.map((vessel) => ({
                  ...vessel,
                  fleetName: fleet.fleetName,
                  fleetId: fleet.fleetId,
                })) || []
            );
            setVesselData(allVessels);
          }
        } catch (error) {
          console.error("Failed to reset to all data:", error);
        }
      };
      fetchAllData();
    }
  }, [filters]);

  const handleFilterChange = (newFilters) => {
    setFilters((prev) => ({
      ...prev,
      fleetId: newFilters.fleetId === "all" ? null : newFilters.fleetId,
      status: newFilters.status || [],
      loadCondition: newFilters.loadCondition || [],
      weather: newFilters.weather || [],
      zone: newFilters.zone || [],
    }));
  };

  return (
    <div className="space-y-6">
      <OverviewFilter
        fleetStats={fleetData}
        allFleetStats={allFleets} // This was empty before!
        totalVesselCount={totalVesselCount}
        onFilterChange={handleFilterChange}
        currentFilters={filters}
        vesselData={vesselData}
      />
      {/* <OverviewScores 
        fleetStats={fleetData}
        selectedFleet={filters.fleetId}
      /> */}
      <FleetMap vessels={vesselData} />
      <OverviewTable vessels={vesselData} />
    </div>
  );
};

export default FleetOverview;